"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveDraft = saveDraft;
exports.getDraft = getDraft;
exports.sendDraft = sendDraft;
exports.deleteDraft = deleteDraft;
exports.spellCheck = spellCheck;
exports.sendCompose = sendCompose;
exports.deleteCompose = deleteCompose;
exports.saveCompose = saveCompose;
exports.endpoints = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _requests = require("@edison/requests");

var _functools = require("@edison/functools");

var _utils = require("./utils");

var _utils2 = require("../utils");

var endpoints = {
  saveDraft: {
    method: 'POST',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/save_draft");
    }
  },
  getDraft: {
    method: 'GET',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/read_thread");
    }
  },
  deleteDraft: {
    method: 'DELETE',
    url: function url(messageId) {
      return "/".concat(_utils2.API_V1, "/delete_draft/").concat(messageId);
    }
  },
  sendDraft: {
    method: 'POST',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/compose_send");
    }
  },
  spellCheck: {
    method: 'POST',
    url: function url(host) {
      return "".concat(host, "/").concat(_utils2.API_V1, "/assist_compose/batch_check");
    }
  },
  saveCompose: {
    method: 'POST',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/compose/save");
    }
  },
  sendCompose: {
    method: 'POST',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/compose/send");
    }
  },
  deleteCompose: {
    method: 'DELETE',
    url: function url(composeId) {
      return "/".concat(_utils2.API_V1, "/compose/").concat(composeId);
    }
  }
};
/**
 * Save draft
 * @param { Draft } draft compose structure
 * @param { Auth } auth signal auth token
 */

exports.endpoints = endpoints;

function saveDraft(_x, _x2) {
  return _saveDraft.apply(this, arguments);
}
/**
 * Read draft
 * @param { Draft } data compose structure
 * @param { Auth } auth auth token
 */


function _saveDraft() {
  _saveDraft = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(draft, _ref) {
    var auth, optionals, _endpoints$saveDraft, method, url, res;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            auth = _ref.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)(draft))({});
            _endpoints$saveDraft = endpoints.saveDraft, method = _endpoints$saveDraft.method, url = _endpoints$saveDraft.url;
            _context.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context.sent;
            return _context.abrupt("return", res);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _saveDraft.apply(this, arguments);
}

function getDraft(_x3, _x4) {
  return _getDraft.apply(this, arguments);
}
/**
 * Compose send
 * @param { Draft } data compose structure
 * @param { Auth } auth auth token
 */


function _getDraft() {
  _getDraft = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(threadId, _ref2) {
    var auth, body, optionals, _endpoints$getDraft, method, url, res;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            auth = _ref2.auth;
            body = {
              id: threadId
            };
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)(body))(_utils.defaultOptionals);
            _endpoints$getDraft = endpoints.getDraft, method = _endpoints$getDraft.method, url = _endpoints$getDraft.url;
            _context2.next = 6;
            return (0, _requests.request)(url(), method, optionals);

          case 6:
            res = _context2.sent;
            return _context2.abrupt("return", res);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getDraft.apply(this, arguments);
}

function sendDraft(_x5, _x6) {
  return _sendDraft.apply(this, arguments);
}
/**
 * Delete draft
 * @param { messageId } draft messageId Draft ID
 * @param { Auth } auth auth token
 */


function _sendDraft() {
  _sendDraft = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(draft, _ref3) {
    var auth, optionals, _endpoints$sendDraft, method, url, res;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            auth = _ref3.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)(draft))(_utils.defaultOptionals);
            _endpoints$sendDraft = endpoints.sendDraft, method = _endpoints$sendDraft.method, url = _endpoints$sendDraft.url;
            _context3.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context3.sent;
            return _context3.abrupt("return", res);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _sendDraft.apply(this, arguments);
}

function deleteDraft(_x7, _x8) {
  return _deleteDraft.apply(this, arguments);
}
/**
 * Spell check
 * @param { texts, whitelist }
 * @param { Auth } auth auth token
 * @return { Array<SpellCheckItem> } spell check structure
 */


function _deleteDraft() {
  _deleteDraft = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(messageId, _ref4) {
    var auth, optionals, _endpoints$deleteDraf, method, url, res;

    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            auth = _ref4.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
            _endpoints$deleteDraf = endpoints.deleteDraft, method = _endpoints$deleteDraf.method, url = _endpoints$deleteDraf.url;
            _context4.next = 5;
            return (0, _requests.request)(url(messageId), method, optionals);

          case 5:
            res = _context4.sent;
            return _context4.abrupt("return", res);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _deleteDraft.apply(this, arguments);
}

function spellCheck(_x9, _x10, _x11) {
  return _spellCheck.apply(this, arguments);
}
/**
 * send compose
 * @param {compose id} composeId
 * @param { Auth } auth
 * @returns null
 */


function _spellCheck() {
  _spellCheck = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(body, auth, host) {
    var optionals, _endpoints$spellCheck, method, url, res;

    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)(body))(_utils.defaultOptionals);
            _endpoints$spellCheck = endpoints.spellCheck, method = _endpoints$spellCheck.method, url = _endpoints$spellCheck.url;
            _context5.next = 4;
            return (0, _requests.request)(url(host), method, optionals);

          case 4:
            res = _context5.sent;
            return _context5.abrupt("return", res);

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _spellCheck.apply(this, arguments);
}

function sendCompose(_x12, _x13) {
  return _sendCompose.apply(this, arguments);
}
/**
 * Delete Compose
 * @param {the id of compose} composeId
 * @param {Auth} auth
 * @returns
 */


function _sendCompose() {
  _sendCompose = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(composeId, auth) {
    var optionals, _endpoints$sendCompos, method, url, res;

    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              composeId: composeId
            }))(_utils.defaultOptionals);
            _endpoints$sendCompos = endpoints.sendCompose, method = _endpoints$sendCompos.method, url = _endpoints$sendCompos.url;
            _context6.next = 4;
            return (0, _requests.request)(url(), method, optionals);

          case 4:
            res = _context6.sent;
            return _context6.abrupt("return", res);

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _sendCompose.apply(this, arguments);
}

function deleteCompose(_x14, _x15) {
  return _deleteCompose.apply(this, arguments);
}
/**
 * Save Compose
 * @param {Compose} compose
 * @param {Auth} auth
 * @returns { SaveComposeResponse}
 */


function _deleteCompose() {
  _deleteCompose = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(composeId, auth) {
    var optionals, _endpoints$deleteComp, method, url, res;

    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
            _endpoints$deleteComp = endpoints.deleteCompose, method = _endpoints$deleteComp.method, url = _endpoints$deleteComp.url;
            _context7.next = 4;
            return (0, _requests.request)(url(composeId), method, optionals);

          case 4:
            res = _context7.sent;
            return _context7.abrupt("return", res);

          case 6:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _deleteCompose.apply(this, arguments);
}

function saveCompose(_x16, _x17) {
  return _saveCompose.apply(this, arguments);
}

function _saveCompose() {
  _saveCompose = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(composeItem, auth) {
    var optionals, _endpoints$saveCompos, method, url, res;

    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)(composeItem))(_utils.defaultOptionals);
            _endpoints$saveCompos = endpoints.saveCompose, method = _endpoints$saveCompos.method, url = _endpoints$saveCompos.url;
            _context8.next = 4;
            return (0, _requests.request)(url(), method, optionals);

          case 4:
            res = _context8.sent;
            return _context8.abrupt("return", res);

          case 6:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _saveCompose.apply(this, arguments);
}
//# sourceMappingURL=compose.js.map